import React, {Component} from 'react';
import './ImagePopup.css';
import Popup from "../../components/popup/Popup";
import Image from "../../components/image/Image";

export default class ImagePopup extends Component{
  render() {
    return(<Popup {...this.props} show={this.props.show} className="g-image-popup">
					<Image src={this.props.src} headers={{'x-auth-token': this.props.token}}/>
		</Popup>
    )
  }
}


// WEBPACK FOOTER //
// ./src/popups/imagePopup/ImagePopup.jsx